module.exports = __webpack_public_path__ + "static/media/logos-login.765d3add.svg";